import {
  ShieldCheck,
  HeartHandshake,
  LineChart,
  Leaf,
  ClipboardList,
  Wrench,
  Users,
  Scale,
  type LucideIcon,
} from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  "shield-check": ShieldCheck,
  "heart-handshake": HeartHandshake,
  "line-chart": LineChart,
  leaf: Leaf,
  "clipboard-list": ClipboardList,
  wrench: Wrench,
  users: Users,
  scale: Scale,
};

interface IconProps {
  name: string;
  className?: string;
}

export default function Icon({ name, className = "h-6 w-6" }: IconProps) {
  const Cmp = iconMap[name] ?? ShieldCheck;
  return <Cmp className={className} aria-hidden="true" />;
}